import { render, staticRenderFns } from "./AppEmptyList.vue?vue&type=template&id=73cec97e&scoped=true&"
import script from "./AppEmptyList.vue?vue&type=script&lang=js&"
export * from "./AppEmptyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cec97e",
  null
  
)

export default component.exports